// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sensors"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.54935 4.95703C1.95768 6.86497 1 9.32026 1 11.9992C1 14.6782 1.95768 17.1335 3.54935 19.0414M7.39017 15.8404C6.52199 14.7997 5.99962 13.4605 5.99962 11.9992C5.99962 10.538 6.52199 9.19872 7.39018 8.15802M20.4502 19.0414C22.0419 17.1335 22.9996 14.6782 22.9996 11.9992C22.9996 9.32027 22.0419 6.86497 20.4502 4.95703M16.609 15.8404C17.4772 14.7997 17.9996 13.4605 17.9996 11.9992C17.9996 10.538 17.4772 9.19872 16.609 8.15802M11.9996 13C11.4473 13 10.9995 12.5523 10.9996 12C10.9996 11.4477 11.4473 11 11.9996 11C12.5518 11 12.9996 11.4477 12.9996 12C12.9996 12.5523 12.5518 13 11.9996 13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SensorsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sensors',
    ref,
    icon: element,
  },
));

SensorsIcon.displayName = 'SensorsIcon';

export default SensorsIcon;
